import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

/** Styling */
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./styles/style.css";
import "./styles/theme.css";

/** Components */
import HomePage from "./components/HomePage";
import LoginPage from "./components/LoginPage";
import RegisterPage from "./components/RegisterPage";
import RecipePage from "./components/RecipePage";
import AccountPage from "./components/Account";
import AppNavBar from "./components/subComponents/NavBar";
import SubmitPage from "./components/SubmitPage";
import AdminPage from "./components/AdminPage";
import ForgotPasswordPage from "./components/ForgotPasswordPage";
import ResetPasswordPage from "./components/ResetPasswordPage";
import ProtectedRoute from "./components/subComponents/ProtectedRoute";
import AdminRoute from "./components/subComponents/AdminRoute";

const PublicLayout = ({ children }: { children: React.ReactNode }) => (
  <>
    <AppNavBar></AppNavBar>
    <main>{children}</main>
  </>
);

const FullScreenLayout = ({ children }: { children: React.ReactNode }) => (
  <main>{children}</main>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <PublicLayout>
              <HomePage />
            </PublicLayout>
          }
        />
        <Route
          path="/login"
          element={
            <FullScreenLayout>
              <LoginPage />
            </FullScreenLayout>
          }
        />
        <Route
          path="/register"
          element={
            <FullScreenLayout>
              <RegisterPage />
            </FullScreenLayout>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <FullScreenLayout>
              <ForgotPasswordPage />
            </FullScreenLayout>
          }
        />
        <Route
          path="/reset-password"
          element={
            <FullScreenLayout>
              <ResetPasswordPage />
            </FullScreenLayout>
          }
        />
        <Route
          path="/recipe/:id"
          element={
            <PublicLayout>
              <RecipePage />
            </PublicLayout>
          }
        />
        <Route
          path="/submit"
          element={
            <ProtectedRoute>
              <PublicLayout>
                <SubmitPage />
              </PublicLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <PublicLayout>
                <AccountPage />
              </PublicLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <PublicLayout>
                <AdminPage />
              </PublicLayout>
            </AdminRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
